import { render, staticRenderFns } from "./wxMarket.vue?vue&type=template&id=ca98da46&scoped=true"
import script from "./wxMarket.vue?vue&type=script&lang=js"
export * from "./wxMarket.vue?vue&type=script&lang=js"
import style1 from "./wxMarket.vue?vue&type=style&index=1&id=ca98da46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca98da46",
  null
  
)

export default component.exports